import { FC } from 'react'

import {
  Text,
  Primary13Regular,
  RedRed60,
  Flex
} from '@sequencehq/core-components'
import { UserMultiSelect } from 'SettingsV2/index'
import { ValidationResult } from 'Automations/nodeDefinitions/validation'

export const UserSelector: FC<{
  'data-testid'?: string
  values: string[] | string
  onChange: (value: string[]) => void
  validationErrors: ValidationResult[] | undefined
}> = ({ 'data-testid': dataTestId, values, onChange, validationErrors }) => {
  const isInvalid: boolean = !!validationErrors?.at(0)
  const normalizedValues = Array.isArray(values) ? values : []

  return (
    <Flex gap="8px" flexDirection="column">
      <UserMultiSelect
        data-testid={dataTestId}
        values={normalizedValues}
        onChange={onChange}
        isInvalid={isInvalid}
      />

      {validationErrors?.at(0) && (
        <Text {...Primary13Regular} color={RedRed60}>
          {validationErrors.at(0)?.message}
        </Text>
      )}
    </Flex>
  )
}
